import { DSButton } from 'designSystem';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Marquee from 'shared/components/Marquee/Marquee';

interface SingleQuickShotProps {
	loading: boolean;
	splitGameName: Array<string | undefined>;
	betValue: number | undefined;
	addToBetSlip: () => void;
	isInBetslip: boolean;
}

const SingleQuickShot: React.FC<SingleQuickShotProps> = ({ loading, splitGameName, betValue, addToBetSlip, isInBetslip }) => {
	const { t } = useTranslation();
	const [buttonClicked, setButtonClicked] = React.useState(false);

	useEffect(() => {
		setButtonClicked(isInBetslip);
	}, [isInBetslip]);

	return (
		<div className="gap-2 flex flex-col h-full">
			<div className="flex-1 min-h-20">
				{splitGameName.map((item, index) => (
					<span key={index} className={index % 2 === 0 ? 'font-semibold' : 'font-normal'}>
						<div className="flex flex-row mx-1">
							<div className="w-2 flex justify-center items-center flex-shrink-0">
								{index % 2 === 0 ? (
									<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="size-[7px] text-gray-100 fill-current">
										<circle cx="50" cy="50" r="50" />
									</svg>
								) : (
									index + 1 < splitGameName.length && <div className="w-[1px] h-[21px] bg-gray-100" />
								)}
							</div>
							<div className="relative px-1 w-full">
								<Marquee text={item as string} />
							</div>
						</div>
					</span>
				))}
			</div>
			<div className="mt-auto">
				<DSButton
					busy={loading}
					color={!buttonClicked ? 'bet' : 'bet-selected'}
					size="medium"
					className="w-full"
					onClick={(e) => {
						addToBetSlip();
						setButtonClicked(!buttonClicked);
						e.currentTarget.blur();
					}}
				>
					<div className="flex flex-col">
						<div className="text-label-2xs font-normal mb-1">{t('addToCoupan')}</div>
						<div className="text-label-lg font-bold">{betValue?.toFixed(2)}</div>
					</div>
				</DSButton>
			</div>
		</div>
	);
};

export default SingleQuickShot;
